if($(document).find('.field.pir-fields')){
    var dom = $(document).find('.field.pir-fields');
    dom.on('click', '.toggle-pir-content', function(){
        dom.toggleClass('active');
    });
}